/** @jsxImportSource @emotion/react */

/**
 * Terms & Conditions Content Component
 * Displays the terms and conditions for external API access
 */
const TermsContent = () => {
  return (
    <div>
      <h2>External API Terms & Conditions</h2>
      <p>
        <strong>Effective Date:</strong> January 26, 2026
      </p>
      <p>
        <strong>Version:</strong> 1.0
      </p>

      <hr />

      <h3>1. API Usage Terms</h3>
      <p>
        By accessing and using the TestSmarter External API, you agree to comply with all applicable
        terms and conditions. The API is provided for the purpose of integrating with your systems
        to access test results, reports, and related data.
      </p>

      <h3>2. Data Privacy and Security</h3>
      <p>
        You are responsible for maintaining the confidentiality of your API credentials (client_id
        and client_secret). You must not share these credentials with unauthorized parties. All API
        requests must be made over secure HTTPS connections. You are responsible for securing any
        data obtained through the API in accordance with applicable privacy laws, including HIPAA
        where applicable.
      </p>

      <h3>3. Rate Limiting and Usage Policies</h3>
      <p>
        API usage is subject to rate limiting to ensure fair access and system stability. Excessive
        requests may result in temporary suspension of API access. You agree to use the API
        responsibly and not to attempt to circumvent rate limits or system protections.
      </p>

      <h3>4. Support and SLA</h3>
      <p>
        API support is provided during standard business hours. While we strive for high
        availability, we do not guarantee 100% uptime. Scheduled maintenance will be communicated
        in advance when possible. We are not liable for any downtime or service interruptions.
      </p>

      <h3>5. Liability Disclaimers</h3>
      <p>
        THE API IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE SHALL
        NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES
        ARISING FROM YOUR USE OF THE API.
      </p>

      <h3>6. Termination and Suspension</h3>
      <p>
        We reserve the right to suspend or terminate your API access at any time for violation of
        these terms, security concerns, or any other reason we deem necessary. Upon termination, you
        must immediately cease all use of the API and delete any stored credentials.
      </p>

      <h3>7. Intellectual Property Rights</h3>
      <p>
        All API documentation, data formats, and related materials are the property of TestSmarter
        and are protected by intellectual property laws. You may not reverse engineer, decompile,
        or disassemble the API or any related software.
      </p>

      <h3>8. Compliance Requirements</h3>
      <p>
        You agree to comply with all applicable laws and regulations, including but not limited to
        HIPAA, GDPR, and other data protection laws. You are responsible for ensuring that your use
        of the API complies with all relevant healthcare and privacy regulations.
      </p>

      <h3>9. Changes to Terms</h3>
      <p>
        We reserve the right to modify these terms at any time. Material changes will be
        communicated to you, and continued use of the API after such changes constitutes
        acceptance of the modified terms. You may be required to re-accept updated terms.
      </p>

      <h3>10. Contact Information</h3>
      <p>
        For questions about these terms or API access, please contact your TestSmarter
        representative or submit a support ticket through the application.
      </p>

      <hr />

      <p>
        <strong>
          By clicking "I Accept the Terms & Conditions" below, you acknowledge that you have read,
          understood, and agree to be bound by these Terms & Conditions.
        </strong>
      </p>
    </div>
  )
}

export default TermsContent
